export default __webpack_public_path__ + "static/media/logo.3ada8a94.png";